/** Picks the teamwork backend: mock (default) or /api/v1 (same origin/session as ../index.ts). */
import { getApi, useMock } from '../index'
import { MockChatApi } from '../mock'
import { HttpCollabApi } from './http'
import { MockCollabApi } from './mock'
import type { CollabApi } from './types'

let current: CollabApi | null = null

export function getCollabApi(): CollabApi {
  if (!current) {
    const chat = getApi()
    if (useMock && chat instanceof MockChatApi) {
      current = new MockCollabApi(chat)
      // mock mode only (screens): lets test/screens-collab.mjs make a colleague reply
      if (typeof window !== 'undefined') (window as unknown as { __cfCollabMock?: CollabApi }).__cfCollabMock = current
    } else current = new HttpCollabApi((import.meta.env.VITE_API_BASE ?? '').trim())
  }
  return current
}

/** Tests inject their own backend. */
export function setCollabApi(api: CollabApi | null): void {
  current = api
}

export type * from './types'
export { isCollabEvent } from './types'
